import { TbKey } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Типи власності авто» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Підстава володіння авто перевізника. У легасі сторінка була відкрита всім (D-31).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListCarOwnershipTypeResource: IResourceConfig = {
    title: 'Типи власності авто',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title', 'code'],
    },
    places: {
        top: <TopMenu current="car-ownership-types" />,
    },
    restUrl: '/services/car_ownership_types',
    pageUrl: '/settings/car-ownership-types',
    pageConfig: {
        title: 'Типи власності авто',
        icon: <TbKey />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
